<template>
  <div class="generate-qr">
    <div class="generate-qr__content">
      <div class="generate-qr__icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h3 class="generate-qr__title">Setup Authenticator App</h3>
      <p class="generate-qr__text">
        Select your preferred setup method to continue with two-factor authentication.
      </p>
      <div class="generate-qr__options">
        <button
          type="button"
          class="generate-qr__option"
          :disabled="qrLoading"
          @click="generateCode('qr_code')"
        >
          <div class="generate-qr__option-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="14" y="14" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
              <rect x="18" y="14" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
              <rect x="14" y="18" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
              <rect x="18" y="18" width="3" height="3" stroke="currentColor" stroke-width="1.5"/>
            </svg>
          </div>
          <div class="generate-qr__option-content">
            <span class="generate-qr__option-title">QR Code</span>
            <span class="generate-qr__option-desc">Scan with your authenticator app</span>
          </div>
          <svg v-if="!qrLoading" class="generate-qr__option-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span v-else class="generate-qr__option-loading"></span>
        </button>
        <button
          type="button"
          class="generate-qr__option"
          :disabled="keyLoading"
          @click="generateCode('setup_key')"
        >
          <div class="generate-qr__option-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M21 2L19 4M19 4L22 7L18.5 10.5L15.5 7.5M19 4L15.5 7.5M11.39 11.61C12.3619 12.5743 12.9011 13.8914 12.8869 15.26C12.8728 16.6287 12.3063 17.9343 11.3142 18.8778C10.3221 19.8213 8.98838 20.3228 7.62073 20.2692C6.25307 20.2156 4.95883 19.6115 4.02299 18.5833C3.08716 17.555 2.58652 16.1892 2.63218 14.7843C2.67784 13.3794 3.26626 12.0498 4.27316 11.0759C5.28007 10.1021 6.62789 9.5581 8.03216 9.57187C9.43644 9.58565 10.7735 10.1559 11.76 11.18L11.39 11.61ZM11.39 11.61L15.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="generate-qr__option-content">
            <span class="generate-qr__option-title">Setup Key</span>
            <span class="generate-qr__option-desc">Enter key manually in app</span>
          </div>
          <svg v-if="!keyLoading" class="generate-qr__option-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span v-else class="generate-qr__option-loading"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "GenerateQrForm",

  emits: ["continue"],

  data() {
    return {
      qrLoading: false,
      keyLoading: false,
    };
  },

  methods: {
    ...mapActions("organisationModule", ["generateQrCode"]),
    async generateCode(type) {
      type === "qr_code" ? (this.qrLoading = true) : (this.keyLoading = true);
      const response = await this.generateQrCode(type);
      if (response) this.$emit("continue");
      this.qrLoading = false;
      this.keyLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.generate-qr {
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 24px;
  }

  &__icon {
    width: 72px;
    height: 72px;
    background: #F1F5F9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    margin-bottom: 20px;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 12px 0;
  }

  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0 0 32px 0;
    line-height: 1.6;
    max-width: 320px;
  }

  &__options {
    width: 100%;
    max-width: 320px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;

    &:hover:not(:disabled) {
      border-color: #4D84FF;
      background: white;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  &__option-icon {
    width: 44px;
    height: 44px;
    background: white;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4D84FF;
    flex-shrink: 0;
  }

  &__option-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__option-title {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #0F172A;
  }

  &__option-desc {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #64748B;
  }

  &__option-arrow {
    color: #64748B;
    flex-shrink: 0;
  }

  &__option-loading {
    width: 20px;
    height: 20px;
    border: 2px solid #E2E8F0;
    border-top-color: #4D84FF;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    flex-shrink: 0;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
